import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cr4nybygzm: FaireBrandEntity = {
  token: "b_cr4nybygzm",
  type: "brand",
  name: "Inanna Healing",
  avatarUrl:
    "https://cdn.faire.com/fastly/397356a8d42e3568ee0ffc552da72fed6f2f4a7c4a735e7d12e5f61a8029e366.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a6684726f392839bdf83435491e96ab96ebd9cf46d65f8b0925e627ef572f079.png",
  logoUrl:
    "https://cdn.faire.com/fastly/397356a8d42e3568ee0ffc552da72fed6f2f4a7c4a735e7d12e5f61a8029e366.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a6684726f392839bdf83435491e96ab96ebd9cf46d65f8b0925e627ef572f079.png",
  location: "Laguna Beach, CA, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Inanna Healing is a small, family-run business based in Laguna Beach, CA. Every product we make is handcrafted in small batches with care, intention, and high-quality natural ingredients. From our Aura Sprays and Anointing Oils to our unique Frequency Generators, everything is infused through our proprietary Charged by Inanna process—combining energetic frequency, sacred numerology, and ritual intention.\n\nOur mission is simple: to help people remember their wholeness. We believe healing isn’t about fixing what’s broken, but reconnecting to the truth that we are already complete. With every spray, oil, or device, we aim to offer tools that uplift the spirit, create sacred space, and bring balance to everyday life.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:21.865Z",
    importedBy: "entity-db-cli",
  },
};
